export default __webpack_public_path__ + "static/media/09.ae126a50.jpg";